import { Token } from "../domain/token";
import { TokenRepository } from "../domain/tokenRepository";

export async function getToken(
  tokenRepository: TokenRepository
): Promise<Token | null> {
  return tokenRepository.get();
}
